import lodash from 'lodash';

import { reportTypes } from './constants';
import { node, nodeWithArgs } from 'common/util/queryHelper';
import styles from '../containers/ReportContent.scss';

export const userDocumentAuditTrailReportColumns = {
    userName: { key: 'userName', label: 'User Name', filter: 'Filter user name' },
    userEmail: { key: 'userEmail', label: 'User Email', filter: 'Filter email' },
    binderName: { key: 'binderName', label: 'Uploaded to Binder' },
    documentName: { key: 'documentName', label: 'Document Name', filter: 'Filter name' },
    actionName: { key: 'actionName', label: 'Action Name', filter: 'Filter action name' },
    actionDate: { key: 'actionDate', label: 'Action Date' },
};

const userDocumentAuditTrailReportColumnsValues = lodash.values(userDocumentAuditTrailReportColumns);

export const userDocumentAuditTrailReportDefaultColumns = lodash.map(userDocumentAuditTrailReportColumnsValues, 'key');

export const userDocumentAuditTrailReportColumnsList = lodash.orderBy(
    userDocumentAuditTrailReportColumnsValues,
    ['label'],
    ['asc'],
);

export const getUserDocumentAuditTrailNode = args => {
    return nodeWithArgs('getUserDocumentAuditTrailReportRawData', args, [
        node('userDocumentAuditTrails', [
            'userName',
            'userEmail',
            'binderName',
            'documentName',
            'actionName',
            'actionDate',
        ]),
        'count',
    ]);
};

const getDefaultFilter = (collection, name) => {
    const findItem = lodash.find(collection, { fieldName: name });
    return findItem ? findItem.value : '';
};

export const formatMaterialTableUserDocumentAuditTrailColumns = (customizeColumns, filters) => {

    return [
        {
            title: userDocumentAuditTrailReportColumns.userName.label,
            field: userDocumentAuditTrailReportColumns.userName.key,
            filterPlaceholder: userDocumentAuditTrailReportColumns.userName.filter,
            emptyValue: <p className={styles.emptyLabel}>No U.N Provided</p>,
            hidden: !customizeColumns.includes(userDocumentAuditTrailReportColumns.userName.key),
            defaultFilter: getDefaultFilter(filters, userDocumentAuditTrailReportColumns.userName.key),
        },
        {
            title: userDocumentAuditTrailReportColumns.userEmail.label,
            field: userDocumentAuditTrailReportColumns.userEmail.key,
            filterPlaceholder: userDocumentAuditTrailReportColumns.userEmail.filter,
            emptyValue: <p className={styles.emptyLabel}>No U.E Provided</p>,
            hidden: !customizeColumns.includes(userDocumentAuditTrailReportColumns.userEmail.key),
            defaultFilter: getDefaultFilter(filters, userDocumentAuditTrailReportColumns.userEmail.key),
        },
        {
            title: userDocumentAuditTrailReportColumns.binderName.label,
            field: userDocumentAuditTrailReportColumns.binderName.key,
            emptyValue: <p className={styles.emptyLabel}>No B.N Provided</p>,
            sorting: false,
            filtering: false,
            hidden: !customizeColumns.includes(userDocumentAuditTrailReportColumns.binderName.key),
            cellStyle: { minWidth: '250px' },
        },
        {
            title: userDocumentAuditTrailReportColumns.documentName.label,
            field: userDocumentAuditTrailReportColumns.documentName.key,
            filterPlaceholder: userDocumentAuditTrailReportColumns.documentName.filter,
            emptyValue: <p className={styles.emptyLabel}>No D.N Provided</p>,
            hidden: !customizeColumns.includes(userDocumentAuditTrailReportColumns.documentName.key),
            defaultFilter: getDefaultFilter(filters, userDocumentAuditTrailReportColumns.documentName.key),
            cellStyle: { minWidth: '250px' },
        },
        {
            title: userDocumentAuditTrailReportColumns.actionName.label,
            field: userDocumentAuditTrailReportColumns.actionName.key,
            filterPlaceholder: userDocumentAuditTrailReportColumns.actionName.filter,
            emptyValue: <p className={styles.emptyLabel}>No A.N Provided</p>,
            hidden: !customizeColumns.includes(userDocumentAuditTrailReportColumns.actionName.key),
            defaultFilter: getDefaultFilter(filters, userDocumentAuditTrailReportColumns.actionName.key),
        },
        {
            title: userDocumentAuditTrailReportColumns.actionDate.label,
            field: userDocumentAuditTrailReportColumns.actionDate.key,
            emptyValue: <p className={styles.emptyLabel}>No A.D Provided</p>,
            filtering: false,
            hidden: !customizeColumns.includes(userDocumentAuditTrailReportColumns.actionDate.key),
            defaultFilter: getDefaultFilter(filters, userDocumentAuditTrailReportColumns.actionDate.key),
        },
    ];
};

export const reportUserDocumentAuditTrailOptionData = {
    name: reportTypes.userDocumentAuditTrail,
    displayName: 'User Document Audit Trail',
    reportType: reportTypes.userDocumentAuditTrail,
    parameters: [
        {
            id: 'institutionId',
            choice: 'institutionId',
            choiceLabel: 'Get a report on all binders for this Institution',
            isChoiceRequired: true,
            isChoiceHidden: true,
            label: 'Institution Id',
            type: null,
            source: null,
            dataKey: 'institutionId',
            target: 'institutionId',
            submit: true,
        },
        {
            id: 'all',
            choice: 'emails',
            choiceLabel: 'Choose a list of email addresses to restrict results to:',
            isChoiceRequired: true,
            isChoiceHidden: false,
            label: 'Include all user emails',
            type: null,
            source: null,
            target: null,
            submit: false,
        },
        {
            id: 'emails',
            choice: 'emails',
            choiceLabel: 'Choose a list of email addresses to restrict results to:',
            isChoiceRequired: false,
            label: 'Include only these user emails',
            type: 'multiselect',
            source: 'emails',
            dataKey: 'emails',
            target: 'emails',
            submit: true,
        },
    ],
};
